import Hero from 'flarum/forum/components/Hero';
import textContrastClass from 'flarum/common/helpers/textContrastClass';
import tagIcon from '../../common/helpers/tagIcon';
import classList from 'flarum/common/utils/classList';
import ItemList from 'flarum/common/utils/ItemList';
export default class TagHero extends Hero {
  className() {
    const tag = this.attrs.model;
    const color = tag.color();
    return classList('TagHero', {
      'TagHero--colored': color,
      [textContrastClass(color)]: color
    });
  }
  style() {
    const tag = this.attrs.model;
    const color = tag.color();
    return color ? {
      '--hero-bg': color
    } : undefined;
  }
  bodyItems() {
    const items = new ItemList();
    items.add('content', m("div", {
      className: "containerNarrow"
    }, this.contentItems().toArray()), 80);
    return items;
  }
  contentItems() {
    const items = new ItemList();
    const tag = this.attrs.model;
    items.add('tag-title', m("h1", {
      className: "Hero-title"
    }, tag.icon() && tagIcon(tag, {}, {
      useColor: false
    }), " ", tag.name()), 100);
    items.add('tag-subtitle', m("div", {
      className: "Hero-subtitle"
    }, tag.description()), 90);
    return items;
  }
}
flarum.reg.add('flarum-tags', 'forum/components/TagHero', TagHero);